import Swiper from 'swiper/bundle';
import "swiper/css/bundle";

class SolutionSolutionsWithDescription {
	static block_name = 'b-solution-solutions-with-description';

	constructor($elem) {
		this.$elem = $elem;
	}

	onInit() {
		const it = this;

		const $itemsName = it.$elem.find(`.${SolutionSolutionsWithDescription.block_name}__name`);

		$itemsName.click(function() {
			let desktop = window.matchMedia('(min-width: 1200px)');
			let num = $(this).data('solution-num');

			if (desktop.matches || !desktop.matches && !$(this).hasClass('active'))	{
				if (!$(this).hasClass('active')) {
					$(this).closest(`.${SolutionSolutionsWithDescription.block_name}__names`).removeClass('open');
				}
				it.$elem.find(`.${SolutionSolutionsWithDescription.block_name}__name[data-solution-num!=` + num + `]`).removeClass('active');
				it.$elem.find(`.${SolutionSolutionsWithDescription.block_name}__name[data-solution-num=` + num + `]`).addClass('active');
				it.$elem.find(`.${SolutionSolutionsWithDescription.block_name}__description[data-solution-num!=` + num + `]`).removeClass('active');
				it.$elem.find(`.${SolutionSolutionsWithDescription.block_name}__description[data-solution-num=` + num + `]`).addClass('active');
			} else {
				if ($(this).hasClass('active')) {
					$(this).closest(`.${SolutionSolutionsWithDescription.block_name}__names`).toggleClass('open');
				}
			}
		});

		/* Swiper - slider */

		this.swiper = {};

		it.$elem.find(`.${SolutionSolutionsWithDescription.block_name}__slider`).each(function(){
			it.swiper[$(this).data('slider-id')] = undefined;
		});

		it.setSwiper();

		$(window).resize(function () {
			it.setSwiper();
		});

	}

	setSwiper() {
		const it = this;

		const $slidersContainers = this.$elem.find(`.${SolutionSolutionsWithDescription.block_name}__slider`);

		let breakpoint = window.matchMedia('(min-width: 1200px)');

		$slidersContainers.each(function(){
			let sliderId = $(this).data('slider-id');

			if (breakpoint.matches) {
				if (it.swiper[sliderId] !== undefined && !it.swiper[sliderId].destroyed) {
					it.swiper[sliderId].destroy(true, true);
					it.swiper[sliderId] = undefined;
				}
			} else {
				if (it.swiper[sliderId] === undefined || it.swiper[sliderId].destroyed) {
					let $description = $(this).closest(`.${SolutionSolutionsWithDescription.block_name}__description`);

					it.swiper[sliderId] = new Swiper(this, {
						speed: 400,
						spaceBetween: 100,
						pagination: {
							bulletClass: `${SolutionSolutionsWithDescription.block_name}__slider-pagination-bullet`,
							bulletActiveClass: `${SolutionSolutionsWithDescription.block_name}__slider-pagination-bullet-active`,
							el: $description.find(`.${SolutionSolutionsWithDescription.block_name}__slider-pagination`).get(0),
							clickable: true,
						},
					});

					let swiper = it.swiper[sliderId];

					setTimeout(function() {
						swiper.update();
						swiper.updateSize();
						swiper.updateSlides();
					}, 500);
				}
			}
		});
	}

}

export default SolutionSolutionsWithDescription;